import styled from 'styled-components'

const Styled = styled.div`
  .ant-picker {
    border-radius: 10px;
    min-width: 100%;
  }

  .container-remove {
    display: flex;
    .wrapper {
      flex: 1;
      padding: 24px;
      margin: 0 10px;
      background-color: #f2f3f7;
      border-radius: 10px;
    }
  }
`

export default Styled
